var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPremiumIcon = function SvgPremiumIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    fill: "currentColor",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 3a1 1 0 0 1 .78.375l.075.106 4.25 7a1 1 0 0 1-.015 1.063l-.077.102-11 13a1 1 0 0 1-1.442.088l-.084-.088-11-13a1 1 0 0 1-.15-1.052l.058-.113 4.25-7a1 1 0 0 1 .725-.473L7.25 3zm-3.235 9h-7.031l3.515 8.672zm5.329 0h-3.171l-2.917 7.195zM8.326 12H5.155l6.087 7.193zm1.348-7H7.811l-3.036 5h3.47zm6.572 0h-4.493l-1.429 5h7.351zm3.942 0h-1.863l1.429 5h3.47z"
  })));
};
export default SvgPremiumIcon;